//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 21.07.2015.
 */

(function () {

    'use strict';

    angular.module('container.core')
        // .constant('OPERATOR_CLIENT_URL', 'clickonce://https://srsng.cse.eu-region.srsng.org/oc/OperatorClient.application')
        // .constant('OPERATOR_CLIENT_URL', 'clickonce://https://sys.eu-region.srsng.org/oc/OperatorClient.application')
        .constant('OPERATOR_CLIENT_URL', '<OPERATOR_CLIENT_URL>')
        // .constant('PROTOCOLHANDLER_INSTALLER_URL', 'https://srsng.cse.eu-region.srsng.org/oc/ProtocolHandlerInstaller.msi')
        .constant('PROTOCOLHANDLER_INSTALLER_URL', '<PROTOCOLHANDLER_INSTALLER_URL>')
        //oc is only enabled if 'true'
        // .constant('OC_ENABLED', 'false')
        .constant('OC_ENABLED', '<OPERATOR_CLIENT_ENABLED>')
        .constant('DASHBOARDINFO', 'DEFAULT')
        .constant('MAINTENANCE_ENABLED',  '<MAINTENANCE_INFO_ENABLED>')
        .constant('MAINTENANCE_INFO_MSG',  '<MAINTENANCE_INFO_MESSAGE>')
        .constant('SOFTWARE_VERSION', 'DEV-VERSION')
        .constant('ENTITY_TYPE', { DEVICE: 'device', EVENT: 'event', RULE: 'rule' })
        .constant('CONTAINER_DATEFORMATS', {
            DEFAULT: 'yyyy-MM-dd',
            WITHTIME: 'yyyy-MM-dd HH:mm',
            WITHTIMEANDSECONDS: 'yyyy-MM-dd HH:mm:ss'
        })
        .constant('OPERATOR_CLIENT_STATUS', {
            UNDEFINED: 'undefined',
            DEGRADED: 'degraded',
            ONLINE: 'online',
            ERROR: 'error',
            CONNECTING: 'connecting'
        })
        .constant('OC_MAX_TRIES', 60)
        .constant('HOME_REGION', '<SRSNG_HOME_REGION>')
        .run(connectWebSocket);
        

    function connectWebSocket(webSocketService) {

        webSocketService.connect();
    }
})();
